// extracted by mini-css-extract-plugin
export var skipToContent = "skip-to-content-module--skipToContent--3b7f6";